import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import type { ReactNode } from 'react';

interface Props {
  open: boolean;
  title: ReactNode;
  width?: string;
  onClose: () => void;
  footer?: ReactNode;
  children: ReactNode;
}

/**
 * Right-side drawer (CLAUDE.md §4.7).
 * Width санал болгох утга:
 *   - 1080px = бүтэн form (items, sale-edit)
 *   - 920px  = харьцангуй бага form
 *   - 600px  = зөвхөн confirmation prompt
 */
export function Drawer({ open, title, width = '440px', onClose, footer, children }: Props) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  return createPortal(
    <>
      <div className={`ts-drawer-overlay ${open ? 'open' : ''}`} onClick={onClose} />
      <aside
        className={`ts-drawer ${open ? 'open' : ''}`}
        style={{ width, maxWidth: '95vw' }}
        role="dialog"
        aria-hidden={!open}
      >
        <div className="ts-drawer-header">
          <h3 className="ts-drawer-title">{title}</h3>
          <button
            type="button"
            className="ts-drawer-close"
            onClick={onClose}
            aria-label="Хаах"
          >
            <i className="bi bi-x-lg" />
          </button>
        </div>
        <div className="ts-drawer-body">{children}</div>
        {footer ? <div className="ts-drawer-footer">{footer}</div> : null}
      </aside>
    </>,
    document.body,
  );
}
